import {
  ComponentComponentsAnswerOption,
  ComponentComponentsQuestion,
  ComponentComponentsFormSection,
  Form,
  Maybe,
} from '../../types/schema';
import { likertReactions } from '../../components/ui/FeedbackQuestion';
import { AnswerState, PromptQuestions } from './types';

export const getQuestions = (form: Form) => {
  const sectionQuestions = (form.formSections || []).map(
    (section) => section?.questions,
  ) as ComponentComponentsQuestion[][];
  if (sectionQuestions && sectionQuestions.length > 0)
    return ([] as ComponentComponentsQuestion[]).concat(...sectionQuestions);
  return null;
};

export const initializeAnswers = (form: Form): AnswerState => {
  const questions = getQuestions(form);
  if (questions)
    return questions.reduce((prev, curr, index) => {
      const options = (
        curr.type === 'fivePointLikertScale'
          ? Object.keys(likertReactions)
          : curr.type === 'nps'
            ? Array.from(Array(10).keys()).map((key) => (key + 1).toString())
            : curr.answerOptions
      )?.map((opt: string | Maybe<ComponentComponentsAnswerOption>) => {
        return {
          title: typeof opt === 'string' ? opt : opt?.title,
        };
      }) as { title: string }[] | undefined;

      prev[curr.title as string] = {
        answer: null,
        required: curr.required || false,
        error: null,
        index: index + 1,
        answerOptions: options,
        hash: curr.hash as string,
      };
      return prev;
    }, {} as AnswerState);
  return {} as AnswerState;
};

export const isSectionComplete = (
  section: ComponentComponentsFormSection | null | undefined,
  answers: AnswerState,
  promptQuestions?: PromptQuestions,
  loadingPromptSections?: { [sectionId: string]: boolean },
): boolean => {
  const sectionId = section?.id;

  if (section?.promptQuestion && sectionId && loadingPromptSections?.[sectionId]) {
    return false;
  }

  if (section?.promptQuestion && sectionId && !promptQuestions?.[sectionId]) {
    return false;
  }

  const allQuestions = [
    ...(section?.questions || []),
    ...(promptQuestions?.[sectionId || ''] || []),
  ];

  if (allQuestions.length === 0) return true;

  return allQuestions.every((question) => {
    const title =
      typeof question === 'object' && question !== null && 'title' in question
        ? question.title
        : '';
    const answer = answers[title || ''];
    return answer?.answer || !answer?.required;
  });
};
